// The composition canvas is defined in raster pixels by the BE contract, so its layer geometry is
// the one place in the app where absolute px values are the correct unit.
export const toCssPx = (value: number) => `${value}px`;
